// Layout sin autenticación para páginas públicas (ej. sello QR del equipo).
// No redirige a login; solo renderiza los children tal cual.
export default function LayoutPublic({ children }) {
  return <>{children}</>;
}
